import React, { Component } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FileUpload from '../../components/FileUpload';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import LinearProgress from '@mui/material/LinearProgress';
import Formatter from '../../utils/Formatter';
import FormsApi from '../../api/forms';
import { connect } from 'react-redux';
import { showError, showMessage, confirmAction } from '../../actions/uiActions';
import {
  addForm,
  updateForm,
  updateServicer,
  addServicer
} from '../../actions/dataActions';
import AnalysisTools from '../../utils/AnalysisTools';
import Servicer from '../../forms/Servicer';
import Form from '../Form';
import { IDR_FORM_ID, TLF_FORM_ID } from '../../constant/formIds';
class AddForm extends Component {
  state = {
    signature_required: false,
    isBorrowerSupportDoc: false,
    isEmployerSupportDoc: false,
    form: '',
    servicer: '',
    file: null,
    busy: false,
    customServicer: false,
    newForm: false,
    editForm: null,
    editServicer: null,
    notes: '',
    dynamicServicer: false,
    borrower_supporting_notes: '',
    employer_supporting_notes: '',
    isFormExist: false,
    employerName: "",
    idrFormPurpose: "",
  };
  handleInputChange = e => {
    if (e.target.value.includes('custom-servicer')) {
      const removeCustomIdentifier = e.target.value.replace(
        'custom-servicer-',
        ''
      );
      this.setState({ [e.target.name]: removeCustomIdentifier });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };
  toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
  add = async (byPass = false) => {
    if (this.state.form === '') {
      this.props.showError(
        'Please select the form you want to assign to the user.'
      );
    }
    else if (
      !AnalysisTools.hasDefaultServicer(this.state.form) &&
      (!this.props.forms.find(f => f.id === this.state.form) ||
        ['esign', 'manual'].includes(
          this.props.forms.find(f => f.id === this.state.form).type
        )) &&
      this.state.servicer === ''
    ) {
      this.props.showError(
        'Please select the servicer to which the form should be sent.'
      );
    }
    else if (
      this.props.forms.find(
        form =>
          form.form == this.state.form && form.servicer == this.state.servicer
      ) &&
      this.state.form != 1 && this.state.form != 2 &&
      this.state.form != 3
    ) {
      this.props.showError('The user already has that form assigned.');
    }
    else if (
      !byPass &&
      AnalysisTools.strategyRecommendsSameIDR(this.props.account) &&
      this.state.form == 0
    ) {
      this.props.confirmAction(
        "You are going to assign the Income Driven Repayment Plan request to this user, and since some of the user's loans are already being repaid under the same IDR plan, it may imply an increase in the monthly payment. Please confirm that you want to assign the Income Driven Repayment Plan request form to the user.",
        () => this.add(true),
        null,
        null,
        null,
        null,
        true
      );
    } else if (this.state.form === TLF_FORM_ID && !this.state.employerName) {
      this.props.showError(
        'Please enter the name of the employer/school'
      );
    } else if (this.state.form == IDR_FORM_ID && !this.state.idrFormPurpose) {
      this.props.showError('You must select the purpose of the IDR form');
    }
    else {
      try {
        let customForm = this.props.forms.find(form => form._id == this.state.form)
        this.setState({ busy: true });
        let file = '';
        if (this.state.file) {
          const base64file = await this.toBase64(this.state.file.file);
          file = {
            data: base64file,
            originalname: this.state.file.file_name,
            fieldname: "file"

          }
        }
        let payload = {
          form: this.state.form,
          servicer: !AnalysisTools.hasDefaultServicer(this.state.form)
            ? this.state.servicer
            : null,
          file,
          signature: this.state.signature_required,
          notes: this.state.notes,
          recertification: false,
          isBorrowerSupportDoc: this.state.isBorrowerSupportDoc,
          borrower_supporting_notes: this.state.borrower_supporting_notes,
          isEmployerSupportDoc: this.state.isEmployerSupportDoc,
          employer_supporting_notes: this.state.employer_supporting_notes,
          formType: customForm !== undefined && customForm.type,
          formName: customForm !== undefined && customForm.name,
        }
        if (this.state.employerName) {
          payload = {
            ...payload,
            employer: {
              employer_name: this.state.employerName
            }
          }
        }
        if (this.state.form == IDR_FORM_ID) {
          payload = {
            ...payload,
            recertification: this.state.idrFormPurpose === "recertification"
          }
        }
        const form = await FormsApi.assignForm(this.props.id, payload)
        this.props.showMessage('The form has been assigned to the user.');
        this.props.onFormAssigned({
          ...form,
          type: this.props.forms.find(f => f.id === this.state.form)
            ? this.props.forms.find(f => f.id === this.state.form).type
            : '',
          notes: this.state.notes
        });
        this.props.onCancel();
      } catch (error) {
        if (typeof error === "string") {
          return this.setState({ busy: false }, this.props.showError(error))
        }
        this.setState({ busy: false }, this.props.showError)
      }
    }
  };
  editForm = () => {
    this.setState({
      editForm: this.state.form
    });
  };
  editServicer = () => {
    this.setState({
      editServicer: this.state.servicer
    });
  };
  shouldShowFormNotes = () => {
    const isFormExist = this.props.forms.find(f => f._id === this.state.form)
    return (this.state.form === "3" || isFormExist)
  }
  setIDRPurpose = (event) => {
    this.setState({ idrFormPurpose: event.target.value })
  }
  render() {
    if (this.state.customServicer || this.state.editServicer) {
      return (
        <Servicer
          mode={this.state.customServicer ? 'add' : 'edit'}
          onCreated={servicer => {
            this.setState({
              servicer: servicer.id
            });
          }}
          onUpdated={servicer => {
            this.props.updateServicer(servicer);
            this.setState({
              servicer: servicer.id,
              customServicer: false,
              editServicer: null
            });
          }}
          onCancel={() =>
            this.setState({ customServicer: false, editServicer: null })
          }
          servicer={this.state.editServicer}
        />
      );
    } else if (this.state.newForm || this.state.editForm) {
      return (
        <Form
          mode={this.state.newForm ? 'add' : 'edit'}
          onCreated={form => {
            this.props.addForm(form);
            this.setState({
              form: form.id,
              newForm: false,
              editForm: null
            });
          }}
          onUpdated={form => {
            this.props.updateForm(form);
            this.setState({
              form: form.id,
              newForm: false,
              editForm: null
            });
          }}
          onCancel={() => this.setState({ newForm: false, editForm: null })}
          form={this.state.editForm}
        />
      );
    }
    return (
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        open={true}
      >
        <DialogTitle id="alert-dialog-title">Assign Form to User</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Complete the information below in order to assign a new form to the
            user. Once you the form is assigned, the user will receive a
            notification.
          </DialogContentText>
          <div className="form-group nice">
            <label>Form Name:</label>
            <select
              name="form"
              onChange={e => {
                if (e.target.value === 'add') {
                  this.setState({ newForm: true });
                } else {
                  this.handleInputChange(e);
                }
              }}
              value={this.state.form}
              disabled={this.state.busy}
              className="form-control"
            >
              <option value="">Select...</option>
              <optgroup label="Standard Forms">
                <option value={0}>Income Driven Repayment Plan Request</option>
                <option value={1}>Direct Consolidation Loan Application</option>
                <option value={2}>
                  Public Service Loan Forgiveness Application
                </option>
                <option value={3}>
                  Public Service Loan Forgiveness Employment Certification
                </option>
                <option value={11}>Repayment Plan Request</option>
              </optgroup>
              <optgroup label="Standard Attachments">
                <option value={5}>Letter to Verify Income</option>
                <option value={9}>Last Year Tax Return</option>
              </optgroup>

              <optgroup label="Other Forms">
                {this.props.forms.map(form => (
                  <option value={form.id} key={form.id}>
                    {form.name}
                  </option>
                ))}
                <option value="add">Add New Form...</option>
              </optgroup>
            </select>
            {this.state.form && !/^[0-9]+$/.test(this.state.form) && (
              <button onClick={this.editForm} className="link">
                Edit Form Settings
              </button>
            )}
          </div>
          {
            this.state.form && this.state.form == IDR_FORM_ID && (
              <div className='form-group nice'>
                <label>Purpose of the IDR form:</label>
                <select name="purpose" className="form-control" onChange={this.setIDRPurpose}>
                  <option value="">Select...</option>
                  <option value="enrollment">For IDR Enrollment or Change of plan</option>
                  <option value="recertification">For IDR Recertification</option>
                </select>
              </div>
            )
          }
          {this.state.form === TLF_FORM_ID && (
            <div className='form-group nice'>
              <label>Employer name:</label>
              <input
                type='text'
                className='form-control'
                value={this.state.employerName}
                onChange={this.handleInputChange}
                name='employerName'
                placeholder='Enter employer/school name'
              />
            </div>
          )}
          {this.state.form &&
            !AnalysisTools.hasDefaultServicer(this.state.form) &&
            (!this.props.forms.find(f => f.id === this.state.form) ||
              ['esign', 'manual'].includes(
                this.props.forms.find(f => f.id === this.state.form).type
              )) && (
              <div className="form-group nice">
                <label>To which Servicer should the form be sent to:</label>
                <select
                  onChange={e => {
                    if (e.target.value === 'add') {
                      this.setState({ customServicer: true });
                    } else {
                      const dynamicServicer = document.querySelector(
                        'select[name="servicer"] option:checked'
                      ).parentElement.label;
                      if (dynamicServicer) {
                        this.setState({
                          dynamicServicer: true
                        });
                        this.handleInputChange(e);
                      } else {
                        this.setState({
                          dynamicServicer: false
                        });
                        this.handleInputChange(e);
                      }
                    }
                  }}
                  name="servicer"
                  value={this.state.servicer}
                  disabled={this.state.busy}
                  className="form-control"
                >
                  <option value="">Select...</option>
                  {Formatter.getServicersList(this.props.myStudentData).map(
                    servicer => (
                      <option key={servicer.id} value={servicer.id}>
                        {servicer.servicer}
                      </option>
                    )
                  )}
                  <optgroup label="Other Servicers">
                    {this.props.servicers.map(servicer => (
                      <option
                        key={`custom-servicer-${servicer.id}`}
                        value={`${servicer.id}`}
                      >
                        {servicer.name}
                      </option>
                    ))}
                    <option value="add">Add new Servicer...</option>
                  </optgroup>
                </select>
                {this.state.servicer && this.state.dynamicServicer && (
                  <button onClick={this.editServicer} className="link">
                    Edit Servicer Settings
                  </button>
                )}
              </div>
            )}
          {this.shouldShowFormNotes(this.state.form) && (
            <div className="form-group nice">
              <label>Form Notes:</label>
              <input
                type="text"
                className="form-control"
                value={this.state.notes}
                onChange={this.handleInputChange}
                name="notes"
                placeholder="Enter any notes specific to this form"
              />
            </div>
          )}
          <div className="form-group nice">
            <label>Upload Filled Form (optional):</label>
            <FileUpload
              disabled={this.state.busy}
              name="file"
              onError={this.props.showError}
              accept=".pdf"
              label="Select File..."
              onChange={file => this.setState({ file })}
              value={this.state.file}
            />
          </div>
          <FormControlLabel control={<Switch disabled={this.state.busy}
            checked={this.state.isBorrowerSupportDoc}
            onChange={(e) => this.setState({ isBorrowerSupportDoc: e.target.checked })}
            value="isBorrowerSupportDoc" />}
            label="This Form Requires a Supporting Document(s) From Borrower"
          />
          {this.state.isBorrowerSupportDoc && (
            <div className="form-group nice">
              <label>Description Supporting Document:</label>
              <input
                type="text"
                className="form-control"
                value={this.state.borrower_supporting_notes}
                onChange={this.handleInputChange}
                name="borrower_supporting_notes"
                placeholder="Enter a description specific to the supporting document(s) for the borrower"
              />
            </div>
          )}
          <FormControlLabel control={<Switch disabled={this.state.busy}
            checked={this.state.isEmployerSupportDoc}
            onChange={(e) => this.setState({ isEmployerSupportDoc: e.target.checked })}
            value="isEmployerSupportDoc" />}
            label="This Form Requires a Supporting Document(s) From Employer"
          />
          {this.state.isEmployerSupportDoc && (
            <div className="form-group nice">
              <label>Description Supporting Document:</label>
              <input
                type="text"
                className="form-control"
                value={this.state.employer_supporting_notes}
                onChange={this.handleInputChange}
                name="employer_supporting_notes"
                placeholder="Enter a description specific to the supporting document(s) for the employer"
              />
            </div>
          )}
          {this.state.busy && <LinearProgress />}
        </DialogContent>
        {!this.state.busy && (
          <DialogActions>
            <Button
              variant="outlined"
              onClick={() => this.add()}
              color="primary"
              autoFocus
            >
              Assign Form
            </Button>
            <Button onClick={this.props.onCancel} color="primary">
              Cancel
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}
const mapStateToProps = state => {
  return {
    servicers: state.data.servicers,
    forms: state.data.forms
  };
};
export default connect(mapStateToProps, {
  showError,
  showMessage,
  confirmAction,
  addForm,
  updateForm,
  updateServicer,
  addServicer
})(AddForm);
